import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.tickets.g.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-page-tickets-g-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.tickets.g.item/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
  background: #f4f4f5;
}`],
})
export class PageTicketsGItemComponent implements OnInit {
    public id: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.id = WizRoute.segment.id;
    }
}

export default PageTicketsGItemComponent;